import VenuesModal from './VenuesModal';

export default VenuesModal;
